'use client';
import createSvgIcon from '../../utils/createSvgIcon';

/**
 * @ignore - internal component.
 */
export default createSvgIcon(
  <path d="M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z" />,
  'LastPage',
);
